export default "__VITE_ASSET__B40lQFF3__"